'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Import class
import OptionSorter from './option-sorter';
import AppleDeviceNameCapitaliser from '../_utils/apple-device-name-capitaliser';

// -----------------------------------------------------------
//  ImageFilterOptions
// -----------------------------------------------------------
const ImageFilterOptions = ({
  category,
  options,
  selected_options: selectedOptions,
  facets,
  onOptionSelected,
  modal,
  newUi,
}) => {
  return (
    <ul className="list-unstyled blob image">
      {new OptionSorter(options.filter(option => option.title))
        .sort()
        .map(renderOption, this)}
    </ul>
  );

  function renderOption(option) {
    const selected = selectedOptions.indexOf(option.title) > -1,
      unavailable = (() => {
        if (facets) {
          return !facets.some(facet => facet.key === option.title);
        }

        return !option.available;
      })();

    const handleOptionSelected = e => {
      e.preventDefault();
      onOptionSelected(option.title);
    };

    if (unavailable & newUi) return null;
    return (
      <li
        key={option.title}
        className={classNames(
          'dropdown-images',
          { selected, unavailable },
          { 'image-items': modal }
        )}>
        <a href="#" onClick={handleOptionSelected}
            className="image-caption"
            aria-label={option.title}
            aria-checked={selected}
            role='checkbox'>
          <img
            src={option.image}
            className="img-fluid"
            alt={`${option.title} ${category}`.toLowerCase()}
          />
          <span className="option-description text-centre">
            <AppleDeviceNameCapitaliser>
              {option.title}
            </AppleDeviceNameCapitaliser>
          </span>
        </a>
      </li>
    );
  }
};

ImageFilterOptions.propTypes = {
  category: PropTypes.string,
  options: PropTypes.array,
  selected_options: PropTypes.array,
  facets: PropTypes.array,
  onOptionSelected: PropTypes.func,
  modal: PropTypes.bool,
  newUi: PropTypes.bool,
};

export default ImageFilterOptions;
